/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
/* eslint-disable import/no-cycle */
import { navigate } from 'gatsby'
import React from 'react'

import { CtaButton, TreatmentContentCard } from '../../components'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import {
  ALLOWED_WORDS,
  ContentParser,
  hasNulls,
  replaceWordInString,
} from '../../utils/helpers'
import {
  btnMargin,
  buttonClassName,
  buttonsContainer,
  headingContainerStyling,
  treatmentCard,
  treatmentCardBigger,
  treatmentCardsContainer,
  treatmentCardsContainerBigger,
} from './TreatmentDetails.module.css'
import TreatmentDetailsFooter from './TreatmentDetailsFooter'

const selfUrl = 'https://essentialaesthetics.nl/'

const TreatmentDetails = ({ lang, slice }) => {
  const {
    membershipbutton,
    treatmentdetailscontent,
    treatmentdetailsheading,
    treatmentdetailskicker,
    treatmentdetailstitle,
    treatmentdetailswidth,
    treatmentsbtnlabel,
  } = slice
  const treatmentCards = ContentParser(slice, 'treatmentdetailscard').filter(
    (item) => item.cardheading,
  )
  const contentCards = ContentParser(slice, 'treatmentcontentcard').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  const width = contentCards.length > 3 ? `45%` : 'container'

  const buttonLink =
    membershipbutton?.url || lang === 'nl'
      ? ' /loyalty-programma/'
      : '/en/loyalty-program/'

  return (
    <SectionLayout
      containerwidth={treatmentdetailswidth}
      extraHeadingContainerClassName={headingContainerStyling}
      heading={replaceWordInString(
        treatmentdetailsheading,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      kicker={treatmentdetailskicker}
      renderedContent={treatmentdetailscontent}
      withHeader
    >
      {treatmentCards.length > 0 && (
        <>
          <div
            className={`${treatmentCardsContainer} ${
              treatmentCards.length > 2 ? treatmentCardsContainerBigger : ''
            }`}
          >
            {treatmentCards.map((card, index) => {
              let cardUrl

              if (
                typeof card.cardlink === 'string' &&
                !card.cardlink.includes(selfUrl)
              ) {
                cardUrl = JSON.parse(card.cardlink)
              }
              if (
                typeof card.cardlink === 'string' &&
                card.cardlink.includes(selfUrl)
              ) {
                cardUrl = { target: `/${card.cardlink.replace(selfUrl, '')}` }
              }

              const item = {
                title: replaceWordInString(
                  card.cardheading,
                  'botox',
                  ALLOWED_WORDS[lang],
                ),
                image: card.cardimage,
                kicker: replaceWordInString(
                  card.cardkicker,
                  'botox',
                  ALLOWED_WORDS[lang],
                ),
                content: replaceWordInString(
                  card.cardcontent,
                  'botox',
                  ALLOWED_WORDS[lang],
                ),
                url: !!(cardUrl && cardUrl.target),
                urlTarget: cardUrl && cardUrl.target ? cardUrl.target : '',
              }
              return (
                <TreatmentContentCard
                  {...item}
                  key={index}
                  extraClassName={
                    treatmentCards.length > 3
                      ? treatmentCard
                      : treatmentCardBigger
                  }
                  setImageHeight
                />
              )
            })}
          </div>
          <div className={buttonsContainer}>
            <CtaButton
              className={btnMargin}
              onClick={() => navigate('#pricing')}
              title={treatmentsbtnlabel}
              type="secondary"
            />
            <CtaButton
              extraClassName={buttonClassName}
              title={membershipbutton?.tilte || 'Become a member'}
              type="secondary"
              url={buttonLink}
              wide
            />
          </div>
        </>
      )}
      {contentCards.length > 0 && (
        <TreatmentDetailsFooter
          contentCards={contentCards.map((item) => {
            return {
              treatmentcardtitle: replaceWordInString(
                item.treatmentcardtitle,
                'botox',
                ALLOWED_WORDS[lang],
              ),
              treatmentcardcontent: replaceWordInString(
                item.treatmentcardcontent,
                'botox',
                ALLOWED_WORDS[lang],
              ),
            }
          })}
          title={treatmentdetailstitle}
          width={width}
        />
      )}
    </SectionLayout>
  )
}

export default TreatmentDetails
